// Always shows log messages in console
// Always pass in an array of arguments
const CatchError = (error) => {
  console.log('ERROR:', error.message)
}

export default CatchError
